import React from "react";

import { useGetApplicationAudits } from "manager/hooks/api";

import SystemAuditsTable, {
  useOpenCreateDealAuditNoteModal,
} from "../SystemAuditsTable";

/** Module-level component so AppTabs can pass a stable type (PRODUCT-2420). */
export const DealActivityTab: React.FC<{ dealId: string }> = ({ dealId }) => {
  const { applicationAudits, isApplicationAuditsLoading } =
    useGetApplicationAudits(dealId);
  const { openCreateAuditNoteModal } = useOpenCreateDealAuditNoteModal({
    dealId,
  });
  return (
    <SystemAuditsTable
      noPadding
      systemAudits={applicationAudits}
      isSystemAuditsLoading={isApplicationAuditsLoading}
      openCreateAuditNoteModal={openCreateAuditNoteModal}
    />
  );
};
